import Vue from "vue";
import Router from "vue-router";
import MainPage from "../Screens/MainPage";
// import MainPage from "../Screens/MainPage";
// import Trivia from "../components/Trivia";
import Login from "../Screens/Login";
import AdminDash from "../Screens/AdminDash";
import SignUp from "../Screens/SignUp";
import UserAdder from "../Screens/UserAdder";
import Attendance from "../Screens/Attendance";
import GamesPage from "../Screens/GamesPage";
import firebase from "firebase";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      redirect: "/login"
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        breadcrumb: [
          {
            text: "Login"
          }
        ]
      }
    },
    {
      path: "/Signup",
      name: "SignUp",
      component: SignUp,
      meta: {
        breadcrumb: [
          {
            text: "Login",
            href: "login"
          },
          { name: "Sign up" }
        ]
      }
    },

    {
      path: "/MainPage",
      name: "MainPage",
      component: MainPage,
      props: true,
      meta: {
        requiresAuth: true,

        breadcrumb: [
          {
            text: "Login",
            href: "login"
          },
          { text: "Main Page" }
        ]
      }
    },
    {
      path: "/AdminDash",
      name: "AdminDash",
      component: AdminDash,
      props: true,
      meta: {
        requiresAuth: true,

        breadcrumb: [
          {
            text: "Login",
            href: "login"
          },
          { text: "Admin Dashboard" }
        ]
      }
    },
    {
      path: "/UserAdder",
      name: "UserAdder",
      component: UserAdder,
      props: true,
      meta: {
        requiresAuth: true,

        breadcrumb: [
          {
            text: "Admin Dashboard",
            href: "AdminDash"
          },
          { text: "User Adder" }
        ]
      }
    },
    {
      path: "/Attendance",
      name: "Attendance",
      component: Attendance,
      props: true,
      meta: {
        requiresAuth: true,
        breadcrumb: [
          {
            text: "Admin Dashboard",
            href: "AdminDash"
          },
          { text: "Attendance" }
        ]
      }
    },

    {
      path: "/GamesPage",
      name: "GamesPage",
      component: GamesPage,
      props: true,
      meta: {
        requiresAuth: true,
        breadcrumb: [
          {
            text: "Admin Dashboard",
            href: "AdminDash"
          },
          { text: "Games" }
        ]
      }
    }
  ],
  mode: "history"
});

router.beforeEach((to, from, next) => {

  let currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

console.log("requiresAuth: "+ requiresAuth+ " currentUser: "+currentUser);
  if((requiresAuth && !currentUser) || (requiresAuth && currentUser==null)) next("Login");
  else next();
//   let requiresAuth = to.matched.some(record => record.meta.requiresAuth);

//   if (requiresAuth && !currentUser) next("/login");
//   else if (requiresAuth && currentUser.isAdmin)
//     next({ name: "AdminDash", params: { uid: currentUser.uid } });
//   else next();
});
// router.beforeEach((to, from, next) => {
//   let currentUser = firebase.auth().currentUser;
//   let requiresAuth = to.matched.some(record => record.meta.requiresAuth);

//   if (requiresAuth && !currentUser) next("/login");
//   else if (requiresAuth && currentUser.isAdmin)
//     next({ name: "AdminDash", params: { uid: currentUser.uid } });
//   else next();
// });

export default router;
